/**
 * Best For Tiles Handler
 * Makes "Best For" tiles interactive - opens calculator and switches tabs
 */

(function() {
  'use strict';
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBestForTiles);
  } else {
    initBestForTiles();
  }
  
  function initBestForTiles() {
    // Find all gwb-product containers
    const products = document.querySelectorAll('.gwb-product');
    
    products.forEach(product => {
      const tiles = product.querySelectorAll('.best-for-item[data-target]');
      
      tiles.forEach(tile => {
        tile.addEventListener('click', () => handleTileClick(tile, product));
        
        // Keyboard support
        tile.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleTileClick(tile, product);
          }
        });
      });
    });
  }
  
  function handleTileClick(tile, product) {
    const target = tile.dataset.target;
    
    // Find the calculator in this product
    const calculator = product.querySelector('.gwb-calculator');
    if (!calculator) return;
    
    // Open calculator details if closed
    const calcDetails = calculator.closest('details');
    if (calcDetails && !calcDetails.open) {
      calcDetails.open = true;
    }
    
    // Scroll to calculator
    calculator.scrollIntoView({ behavior: 'smooth', block: 'start' });
    
    // Switch to the appropriate tab after brief delay
    setTimeout(() => {
      const targetTab = calculator.querySelector(`.calc-tab[data-target="${target}"]`);
      if (targetTab) {
        targetTab.click();
        targetTab.focus();
      }
    }, 300);
  }
  
})();